import * as THREE from 'three'

const treeConfig = {
  amount: 2000,
  minSpread: 20,
  spreadRadius: 1000,
  trunk: {
    color: "brown"
  },
  bush: {
    color: "darkgreen"
  }
}

let forest = null
let tree = null
let treeTrunkGeometry = null
let treeBushGeometry = null
let treeTrunkMaterial = null
let treeBushMaterial = null

const createTrees = (scene, gui) => {
  if (forest !== null) {
    treeTrunkGeometry.dispose()
    treeBushGeometry.dispose()
    treeTrunkMaterial.dispose()
    treeBushMaterial.dispose()
    scene.remove(forest)
  }

  forest = new THREE.Group()
  scene.add(forest)
  treeTrunkMaterial = new THREE.MeshStandardMaterial({ color: treeConfig.trunk.color})
  treeBushMaterial = new THREE.MeshStandardMaterial({ color: treeConfig.bush.color})

  for (let i = 0; i < treeConfig.amount; i++) {
    const treeAngle = Math.random() * Math.PI * 2
    const treeDist = treeConfig.minSpread + Math.random() * (treeConfig.spreadRadius - treeConfig.minSpread)

    tree = new THREE.Group()
    forest.add(tree)

    treeTrunkGeometry = new THREE.BoxGeometry(1, 6, 1)
    const treeTrunkMesh = new THREE.Mesh(treeTrunkGeometry, treeTrunkMaterial)
    treeTrunkMesh.position.y = 1
    tree.add(treeTrunkMesh)

    treeBushGeometry = new THREE.BoxGeometry(6, 10, 6)
    const treeBushMesh = new THREE.Mesh(treeBushGeometry, treeBushMaterial)
    treeBushMesh.position.y = 9
  
    tree.position.x = Math.sin(treeAngle) * treeDist
    tree.position.z = Math.cos(treeAngle) * treeDist

    tree.add(treeBushMesh)
  }

  return forest
}

const addGuiToTrees = (scene, gui) => {

}

export {
  createTrees,
  addGuiToTrees
}